import {
  Button,
  Card,
  CardContent,
  InputTextArea,
} from "@sellar-io/components";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { useForm } from "react-hook-form";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { useSupplierUpdate } from "../../../hooks/api/v2/supplier/useSupplierUpdate";
import { useSellarSupplier } from "../../../hooks/useSellarSupplier";

export const StorefrontSettingsPaymentNotesCard = ({
  paymentNotes,
}: {
  paymentNotes: SupplierGetResponseType["paymentNotes"];
}) => {
  const supplier = useSellarSupplier();

  const supplierUpdateMutation = useSupplierUpdate(supplier.id);
  const { handleSubmit, register, formState } = useForm({
    shouldUseNativeValidation: true,
    defaultValues: {
      paymentNotes,
    },
  });

  return (
    <Card className="bg-white">
      <CardContent className={"p-4"}>
        <form
          onSubmit={handleSubmit((data) => {
            supplierUpdateMutation.mutate({
              paymentNotes: data.paymentNotes,
            });
          })}
        >
          <InputLabel>Payment notes</InputLabel>
          <InputContainer>
            <InputTextArea
              variant="legacyFixed"
              {...register("paymentNotes", {
                required: false,
                disabled: supplierUpdateMutation.isPending,
              })}
              placeholder={"Payment notes"}
            />
          </InputContainer>
          <div className="mt-4 flex justify-end">
            <Button
              type={"submit"}
              loading={supplierUpdateMutation.isPending}
              disabled={!formState.isDirty}
            >
              Save Changes
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};
